/**
 * Check whether the string provided is a CSS variable function
 *
 * @param cssVariable The string to be tested
 * @returns True or false
 */
export function isCssVarFunc(cssVariable) {
    return cssVariable.startsWith('var(--') && cssVariable.endsWith(')');
}
